import React, { useEffect } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import { ReactComponent as CheckSvg } from "../../assets/icons/generic/GreenCheckSquared.svg";
import StripePlan from "./StripePlan";
import EnterprisePlanMUAProgress from "./EnterprisePlanMUAProgress";
import PrimaryButton from "../Generic/PrimaryButton";
import SecondaryButton from "../Generic/SecondaryButton";
import DeleteConfirmationChild from "../Generic/DeleteConfirmationWithChild";
import { CANCEL_PLAN } from "../../constants/OptionsConstants";
import AdminRoleRequired from "../../helper/AdminRoleRequired";
import FreePlanMUAProgress from "./FreePlanMUAProgress";

const ListElement = ({ text }) => {
  return (
    <ElementWrapepr>
      <CheckSvg />
      <p>{text}</p>
    </ElementWrapepr>
  );
};

const PlanContent = ({
  plan,
  planLoaded,
  isEnterprise,
  setIsModalOpen,
  setIsCancelConfirmationOpen,
  isCancelCOnfirmationOpen,
  handleCancelSubscription,
}) => {
  return (
    <Container>
      <TitleWrapper>
        <h1>
          {" "}
          {planLoaded &&
            (plan
              ? plan.type === "stripe"
                ? "Scale Up"
                : plan.type === "enterprise"
                ? "Enterprise"
                : "Free plan"
              : "Free plan")}
        </h1>
      </TitleWrapper>

      {planLoaded &&
        (plan ? (
          plan.type === "stripe" ? (
            <StripePlan plan={plan} />
          ) : plan.type === "enterprise" ? (
            <EnterprisePlanMUAProgress plan={plan} />
          ) : (
            <FreePlanMUAProgress />
          )
        ) : (
          <FreePlanMUAProgress />
        ))}

      <AdminRoleRequired>
        <Line>
          {plan && !isEnterprise && (
            <DeleteConfirmationChild
              open={isCancelCOnfirmationOpen}
              setOpen={setIsCancelConfirmationOpen}
              action={handleCancelSubscription}
              variant={CANCEL_PLAN}
            >
              <SecondaryButton
                variant={lightThemeColors.darkColorFaded30}
                text={"Cancel Plan"}
                onClick={() => setIsCancelConfirmationOpen(true)}
              />
            </DeleteConfirmationChild>
          )}

          {!isEnterprise && (
            <PrimaryButton
              text={"Change Plan"}
              onClick={() => setIsModalOpen(true)}
            />
          )}
        </Line>
      </AdminRoleRequired>
    </Container>
  );
};

export default PlanContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  h1 {
    color: ${lightThemeColors.primaryColor};
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
  }
`;
const PointList = styled.ul`
  gap: 20px;
  display: flex;
  flex-direction: column;
`;

const ElementWrapepr = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  p {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
`;
const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
